<div class="request-classification-container">
	<div class="dotted-input-container" *ngIf="_availableClassification.solutionArea.length > 0 && !hideField.includes('solutionArea')">
		<span>{{ labels.lbl_geral_grupo }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.solutionAreaIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idSolutionArea"
			(onValueChange)="
				_idSolutionArea = $event; resetAvailableClassificationUntil('solutionArea'); wasClassificationEditedAfterLoad.emit(true)
			"
			(onCleanValues)="resetSelectedClassificationUntil('solutionArea')"
			(onValueSelected)="cascateClassification(solutionAreaIAC)"
			[disabled]="lockField?.includes('solutionArea') || _isCascating"
			#solutionAreaIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="_idSolutionArea != undefined && _availableClassification.serviceType.length > 0 && !hideField.includes('serviceType')">
		<span>{{ labels.lbl_chamado_tipo_servico }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.serviceTypeIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idServiceType"
			(onValueChange)="
				_idServiceType = $event; resetAvailableClassificationUntil('serviceType'); wasClassificationEditedAfterLoad.emit(true)
			"
			(onCleanValues)="resetSelectedClassificationUntil('serviceType')"
			(onValueSelected)="cascateClassification(serviceTypeIAC)"
			[disabled]="lockField?.includes('serviceType') || _isCascating"
			#serviceTypeIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="_idServiceType != undefined && _availableClassification.scope.length > 0 && !hideField.includes('scope')">
		<span>{{ labels.lbl_geral_competencia }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.scopeIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idScope"
			(onValueChange)="_idScope = $event; resetAvailableClassificationUntil('scope'); wasClassificationEditedAfterLoad.emit(true)"
			(onCleanValues)="resetSelectedClassificationUntil('scope')"
			(onValueSelected)="cascateClassification(scopeIAC)"
			[disabled]="lockField?.includes('scope') || _isCascating"
			#scopeIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="_idScope != undefined && _availableClassification.category.length > 0 && !hideField.includes('category')">
		<span>{{ labels.lbl_geral_natureza }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.categoryIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idCategory"
			(onValueChange)="
				_idCategory = $event; resetAvailableClassificationUntil('category'); wasClassificationEditedAfterLoad.emit(true)
			"
			(onCleanValues)="resetSelectedClassificationUntil('category')"
			(onValueSelected)="cascateClassification(categoryIAC)"
			[disabled]="lockField?.includes('category') || _isCascating"
			#categoryIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="_idCategory != undefined && _availableClassification.topic.length > 0 && !hideField.includes('topic')">
		<span>{{ labels.lbl_geral_topico }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.topicIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idTopic"
			(onValueChange)="_idTopic = $event; resetAvailableClassificationUntil('topic'); wasClassificationEditedAfterLoad.emit(true)"
			(onCleanValues)="resetSelectedClassificationUntil('topic')"
			(onValueSelected)="cascateClassification(topicIAC)"
			[disabled]="lockField?.includes('topic') || _isCascating"
			#topicIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			(_idServiceType?.toString() == '1' || _idServiceType?.toString() == '2') &&
			_idTopic != undefined &&
			_availableClassification.impact.length > 0 &&
			!hideField.includes('impact')
		">
		<span>{{ labels.lbl_geral_impacto }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.impactIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idImpact"
			(onValueChange)="_idImpact = $event; resetAvailableClassificationUntil('impact'); wasClassificationEditedAfterLoad.emit(true)"
			(onCleanValues)="resetSelectedClassificationUntil('impact')"
			(onValueSelected)="cascateClassification(impactIAC)"
			[disabled]="lockField?.includes('impact') || _isCascating"
			#impactIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			(_idServiceType?.toString() == '1' || _idServiceType?.toString() == '2') &&
			_idTopic != undefined &&
			_availableClassification.urgency.length > 0 &&
			!hideField.includes('urgency')
		">
		<span>{{ labels.lbl_geral_urgencia }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.urgencyIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idUrgency"
			(onValueChange)="_idUrgency = $event; resetAvailableClassificationUntil('urgency'); wasClassificationEditedAfterLoad.emit(true)"
			(onCleanValues)="resetSelectedClassificationUntil('urgency')"
			(onValueSelected)="cascateClassification(urgencyIAC)"
			[disabled]="lockField?.includes('urgency') || _isCascating"
			#urgencyIAC>
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			(_idServiceType?.toString() == '1' || _idServiceType?.toString() == '2') &&
			_idImpact != undefined &&
			_idUrgency != undefined &&
			_availableClassification.severity.length > 0 &&
			!hideField.includes('severity')
		">
		<span>{{ labels.lbl_geral_severidade }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="_availableClassification.severityIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="_idSeverity"
			[disabled]="true">
		</cpi-input-with-autocomplete>
	</div>

	<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="_isCascating"></cpi-dot-bounce-loading-effect>
</div>
